import React, { useState, useEffect } from 'react';

const EditarLabores = (p) => {
    const original = p.data ? { ...p.data } : { duracion: 1, fecha_ancla: "", id: null, inicio_desde_ancla: 0, inventario: "", labor: "" };

    const [modif, setmodif] = useState({ ...p.data });
    const changeValue = (event) => {
        let { name, value } = event.target;
        if (name === 'labor') value = value.toUpperCase();
        console.log(`name`, name, value);
        setmodif({ ...modif, [name]: value });
    }

    const update = async (update, deleteReg = false) => {
        let data = { ...modif };
        data.tipo = 'labores';
        if (await p.update(data, update, deleteReg)) p.close();
    }

    return (
        <div className='vw-100 vh-100 blur-s bg-white5' style={{ position: "fixed", top: 0, left: 0, zIndex: 10, }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>

                <div className='bw-1000 bg-white2 p-2 pt-3 pb-3 blur-xxl round-s shadow-multi mt-5'>
                    <div className='w-100 text-end' style={{ position: "sticky", left: 0, top: 0, zIndex: 15 }}>
                        <button className='btn btn-danger shadow me-2 round-xl border border-2 scale-continue-05' onClick={p.close}>Cerrar</button>
                    </div>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {!p.data && <>
                            <div className='bw-300 mt-2 mb-5 text-bold border-bottom  border-warning  h3'>Nueva labor</div>
                            <div className='w-100'></div>
                        </>}
                        <div className='form-group bw-300 m-1'>
                            <label className='text-bold text-start'>NOMBRE DE LABOR</label>
                            <input type='text' maxLength={255} minLength={1} className='form-control shadow border' name='labor' value={modif.labor} onChange={changeValue} />
                        </div>
                        <div className='form-group bw-300 m-1'>
                            <label className='text-bold text-start'>SEMANA ASOCIADA</label>
                            <select className='form-control shadow border' name='fecha_ancla' value={modif.fecha_ancla} onChange={changeValue}>
                                <option value='' >SELECCIONE UNA</option>
                                <option value='SIEMBRA' >SIEMBRA</option>
                                <option value='TRANSPLANTE' >TRANSPLANTE</option>
                                <option value='CORTE' >CORTE</option>
                            </select>
                        </div>
                        <div className='form-group bw-350 m-1'>
                            <label className='text-bold text-start'>INICIO DESDE SEMANA ASOCIADA</label>
                            <input type='number' className='form-control shadow border' name='inicio_desde_ancla' min={-15} max={15} value={modif.inicio_desde_ancla} onChange={changeValue} />
                        </div>
                        <div className='form-group bw-350 m-1'>
                            <label className='text-bold text-start'>DURACIÓN</label>
                            <select className='form-control shadow border' name='duracion' value={modif.duracion} onChange={changeValue}>
                                <option value={0} >TODO EL CICLO</option>
                                <option value={1} >1 SEMANA</option>
                                <option value={2} >2 SEMANAS</option>
                                <option value={3} >3 SEMANAS</option>
                                <option value={4} >4 SEMANAS</option>
                                <option value={5} >5 SEMANAS</option>
                                <option value={6} >6 SEMANAS</option>
                                <option value={7} >7 SEMANAS</option>
                                <option value={8} >8 SEMANAS</option>
                                <option value={9} >9 SEMANAS</option>
                                <option value={10} >10 SEMANAS</option>
                                <option value={11} >11 SEMANAS</option>
                                <option value={12} >12 SEMANAS</option>
                                <option value={13} >13 SEMANAS</option>
                                <option value={14} >14 SEMANAS</option>
                                <option value={15} >15 SEMANAS</option>
                            </select>

                        </div>
                        <div className='form-group bw-350 m-1'>
                            <label className='text-bold text-start'>INVENTARIO ASOCIADO</label>
                            <select className='form-control shadow border' name='inventario' value={modif.inventario} onChange={changeValue}>
                                <option value='' >NINGUNO</option>
                                <option value='EJECUCIÓN DE SIEMBRA POR DÍA' >EJECUCIÓN DE SIEMBRA POR DÍA</option>
                                <option value='INVENTARIO DE VIVERO' >INVENTARIO DE VIVERO</option>
                                <option value='PROGRAMA DE CONSOLIDACIÓN POR DÍA' >PROGRAMA DE CONSOLIDACIÓN POR DÍA</option>
                                <option value='ENTREGA DE VIVERO A CAMPO' >ENTREGA DE VIVERO A CAMPO</option>
                            </select>
                        </div>

                        <div className='w-100 mt-4 mb-3 text-center'>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                {modif.id && <button className='btn btn-danger bg-red3 text-white shadow text-bold border border scale-025 round-xxl bw-100'
                                    onClick={() => { update(false, true) }}
                                >Eliminar</button>}
                                {
                                    p.data && <button className='btn btn-warning shadow text-red4 text-bold border border scale-025 ps-5 pe-5 round-xxl bw-300'
                                        onClick={() => { update(false) }}
                                    >Guardar como nuevo registro</button>
                                }
                                <button className='btn btn-warning shadow text-red4 text-bold border border scale-025 ps-5 pe-5 round-xxl bw-200'
                                    onClick={() => { update(p.data ? true : false) }}
                                >{p.data ? "Guardar cambios" : "Crear registro"}</button>
                            </div>

                        </div>
                    </div>
                </div>


            </div>
        </div >
    )
}

export default EditarLabores;